export function parseFileUrl(url: string): {
  folderName: string;
  fileName: string;
} {
  // URL 객체를 생성
  const parsedUrl = new URL(url);

  // path를 슬래시로 분할
  const paths = parsedUrl.pathname.split("/").filter(Boolean);

  // paths 배열에서 마지막 요소는 파일명, 그 전 요소는 폴더명
  const fileName = paths.pop() || "";
  const folderName = paths.pop() || "";

  return { folderName, fileName };
}
